import { render, staticRenderFns } from "./Three.vue?vue&type=template&id=954a07ba&scoped=true"
import script from "./Three.vue?vue&type=script&lang=js"
export * from "./Three.vue?vue&type=script&lang=js"
import style0 from "./Three.vue?vue&type=style&index=0&id=954a07ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954a07ba",
  null
  
)

export default component.exports